    
var video_slide = new Swiper ('.main-video', {

    direction: 'horizontal',
    loop: false,
  
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: '.main-next',
      prevEl: '.main-prev',
    },
    on: {
        slideChangeTransitionStart: function () {
            if (window.innerWidth <= 990) { // 모바일 (768px 이하)에서만 실행
                document.querySelectorAll('.swiper-slide .txt-con').forEach(el => {
                    el.style.opacity = '0';
                    el.style.transform = 'translateX(40%)';
                });
            }
        },
        slideChangeTransitionEnd: function () {
            if (window.innerWidth <= 990) { // 모바일 (768px 이하)에서만 실행
                let activeSlide = document.querySelector('.swiper-slide-active .txt-con');
                if (activeSlide) {
                    activeSlide.style.opacity = '1';
                    activeSlide.style.transform = 'translateX(0)';
                }
            }
        }
    }
     // autoplay:{
     //  delay: 5000,
     //  disableOnInteraction: false  
     // }
  });





